<template>
  <div>
    <div class="row">
      <div class="col-xs-3 vcenter">
        <div class="circle text-center vcenter">
          <svg
            aria-hidden="true"
            data-prefix="fas"
            data-icon="user"
            class="categoryIcon"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
            color="#fff"
          >
            <path
              fill="currentColor"
              d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
            />
          </svg>
        </div>
      </div>
      <div class="col-xs-10 vcenter">
        <p class="title">Обо мне</p>
      </div>
    </div>
    <div class="row aboutitem">
      <div class="col-xs-12 vcenter">
        <AboutItem :value="age" />
        <AboutItem v-for="item in items" :key="item.value" :value="item" />
      </div>
    </div>
  </div>
</template>

<script>
import AboutItem from "./AboutItem";

export default {
  name: "About",
  props: {
    items: {}
  },
  data() {
    return {
      age: {
        icon:
          '<svg aria-hidden="true" data-prefix="fas" data-icon="birthday-cake" class="ageIcon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" color="#c3c2c2"><path fill="currentColor" d="M448 384c-28.02 0-31.26-32-74.5-32-43.43 0-46.825 32-74.75 32-27.695 0-31.454-32-74.75-32-42.842 0-47.218 32-74.5 32-28.148 0-31.202-32-74.75-32-43.547 0-46.653 32-74.75 32v-80c0-26.5 21.5-48 48-48h16V112h64v144h64V112h64v144h64V112h64v144h16c26.5 0 48 21.5 48 48v80zm0 128H0v-96c43.356 0 46.767-32 74.75-32 27.951 0 31.253 32 74.75 32 42.843 0 47.217-32 74.5-32 28.148 0 31.201 32 74.75 32 43.357 0 46.767-32 74.75-32 27.488 0 31.252 32 74.5 32v96zM96 96c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40z"></path></svg>',
        value: this.declOfNum(
          this.dateDiffInYears(new Date(1986, 2, 15), new Date()),
          ["год", "года", "лет"]
        )
      }
    };
  },
  components: {
    AboutItem
  },
  methods: {
    declOfNum(number, titles) {
      let cases = [2, 0, 1, 1, 1, 2];
      return (
        number +
        " " +
        titles[
          number % 100 > 4 && number % 100 < 20
            ? 2
            : cases[number % 10 < 5 ? number % 10 : 5]
        ]
      );
    },
    dateDiffInYears(dateold, datenew) {
      let ynew = datenew.getFullYear();
      let mnew = datenew.getMonth();
      let dnew = datenew.getDate();
      let yold = dateold.getFullYear();
      let mold = dateold.getMonth();
      let dold = dateold.getDate();
      let diff = ynew - yold;
      if (mold > mnew) diff--;
      else {
        if (mold === mnew) {
          if (dold > dnew) diff--;
        }
      }
      return diff;
    }
  }
};
</script>
